module.exports = __webpack_public_path__ + "img/pic9.ecae6718.jpg";